import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PlatformState } from './shared/states/platform.state';
import firstUserAccess from './utils/firstUserAccess';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  constructor(
    public router: Router,
    public platform: PlatformState,
  ) {
    platform.update();
    firstUserAccess.setTrueIfInexistent();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window['ga']('set', 'page', event.urlAfterRedirects);
        window['ga']('send', 'pageview');
      }
    });
  }

}
